module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Spiel")])]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "score"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.status == 'ready' ? _vm.submitScore() : _vm.confirmScore()
      }
    }
  }, [_c('section', {
    attrs: {
      "id": "match"
    }
  }, [_c('router-link', {
    staticClass: "player",
    attrs: {
      "to": ("/profile/" + (_vm.match.player_a_id))
    }
  }, [_c('dp', {
    attrs: {
      "who": _vm.match.player_a
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.match.player_a.firstname) + " " + _vm._s(_vm.match.player_a.lastname))])], 1), _vm._v(" "), _c('div', {
    staticClass: "vs"
  }, [_vm._v("vs")]), _vm._v(" "), _c('router-link', {
    staticClass: "player",
    attrs: {
      "to": ("/profile/" + (_vm.match.player_b_id))
    }
  }, [_c('dp', {
    attrs: {
      "who": _vm.match.player_b
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.match.player_b.firstname) + " " + _vm._s(_vm.match.player_b.lastname))])], 1)], 1), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.match.games), function(game, i) {
    return _c('th', [_vm._v("\n                        " + _vm._s(i + 1) + "ter"), _c('br'), _vm._v("Satz\n                    ")])
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "player"
  }, [_c('dp', {
    attrs: {
      "who": _vm.match.player_a
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.match.player_a.firstname[0] + _vm.match.player_a.lastname[0]))])], 1), _vm._v(" "), _vm._l((_vm.match.games), function(game, idx) {
    return _c('td', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (game.points_a),
        expression: "game.points_a"
      }],
      attrs: {
        "type": "text",
        "min": "0",
        "inputmode": "numeric",
        "pattern": "[0-9]*",
        "disabled": _vm.status != 'ready',
        "tabindex": 2 * idx + 1
      },
      domProps: {
        "value": (game.points_a)
      },
      on: {
        "focus": function($event) {
          $event.target.setSelectionRange(0, 9999)
        },
        "change": _vm.storeLocally,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(game, "points_a", $event.target.value)
        }
      }
    })])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "player"
  }, [_c('dp', {
    attrs: {
      "who": _vm.match.player_b
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.match.player_b.firstname[0] + _vm.match.player_b.lastname[0]))])], 1), _vm._v(" "), _vm._l((_vm.match.games), function(game, idx) {
    return _c('td', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (game.points_b),
        expression: "game.points_b"
      }],
      attrs: {
        "type": "number",
        "min": "0",
        "inputmode": "numeric",
        "pattern": "[0-9]*",
        "disabled": _vm.status != 'ready',
        "tabindex": 2 * idx + 2
      },
      domProps: {
        "value": (game.points_b)
      },
      on: {
        "focus": function($event) {
          $event.target.select()
        },
        "change": _vm.storeLocally,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(game, "points_b", $event.target.value)
        }
      }
    })])
  })], 2)])]), _vm._v(" "), (_vm.status == 'ready') ? _c('input', {
    staticClass: "btn btn-primary center",
    attrs: {
      "type": "submit",
      "value": "Speichern"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.status == 'confirming') ? _c('input', {
    staticClass: "btn btn-primary center",
    attrs: {
      "type": "submit",
      "value": "Akzeptieren"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.status == 'confirming') ? _c('a', {
    staticClass: "btn btn-link center",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.rescore()
      }
    }
  }, [_vm._v("\n            Ändern\n        ")]) : _vm._e(), _vm._v(" "), (_vm.rescoring) ? _c('a', {
    staticClass: "btn btn-link center",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stopRescore()
      }
    }
  }, [_vm._v("\n            Abbrechen\n        ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2963fd44","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/score.vue
// module id = 222
// module chunks = 0